import React, { useState } from 'react'
import { Slide } from '../types'
import { useDispatch } from 'react-redux'
import { SET_ACTIVE_SLIDE } from '../redux/manageSlidesReducer'

const SLIDE_WIDTH = 800
const SLIDE_HEIGHT = 500
const SCALE = 0.35

type Props = {
  item: Slide
}

const SlideListItem = ({ item }: Props) => {
  const dispatch = useDispatch()
  return (
    <>
      <div
        onClick={() => dispatch(SET_ACTIVE_SLIDE(item))}
        className="relative shadow-xl cursor-pointer"
        style={{
          width: `${SLIDE_WIDTH * SCALE}px`,
          height: `${SLIDE_HEIGHT * SCALE}px`,
          overflow: 'hidden'
        }}>
        <div
          className="origin-top-left absolute top-0 left-0 z-[-20]"
          style={{
            transform: `scale(${SCALE})`,
            transformOrigin: 'top left'
          }}
          ref={(node) => {
            if (node) {
              if (!node.shadowRoot) {
                const shadowRoot = node.attachShadow({ mode: 'open' })
                shadowRoot.innerHTML = item.html
              } else {
                node.shadowRoot.innerHTML = item.html
              }
            }
          }}
        />
      </div>
    </>
  )
}

export default SlideListItem
